import { render, staticRenderFns } from "./InvoiceOptik.vue?vue&type=template&id=97054f26&"
import script from "./InvoiceOptik.vue?vue&type=script&lang=js&"
export * from "./InvoiceOptik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports